const BASE_QUERY_KEY=["Currencies"];export const CURRENCIES_QUERY_KEYS={currencyExchangeRates:currency=>[...BASE_QUERY_KEY,"ExchangeRates",currency]};